export default __webpack_public_path__ + "static/media/blur-1950.6e40fc65.png";